// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.links-container {
  padding: 2rem;
  max-width: 1400px;
  margin: 0 auto;
}

.links-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
}

.links-header h1 {
  font-size: 2.5rem;
}

.bulk-actions {
  display: flex;
  gap: 0.75rem;
  flex-wrap: wrap;
}

.bulk-action-btn {
  color: #ffffff;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-weight: 600;
  transition: all 0.3s ease;
}

.bulk-action-btn.downloaded {
  background-color: #10b981;
}

.bulk-action-btn.downloaded:hover {
  background-color: #059669;
  transform: translateY(-2px);
}

.bulk-action-btn.not-downloaded {
  background-color: #6b7280;
}

.bulk-action-btn.not-downloaded:hover {
  background-color: #4b5563;
  transform: translateY(-2px);
}

.bulk-action-btn.delete {
  background-color: #ef4444;
}

.bulk-action-btn.delete:hover {
  background-color: #dc2626;
  transform: translateY(-2px);
}

.links-filters {
  display: flex;
  gap: 1rem;
  margin-bottom: 2rem;
  flex-wrap: wrap;
}

.search-form {
  flex: 1 1;
  min-width: 300px;
  display: flex;
  align-items: center;
  background: rgba(26, 26, 46, 0.6);
  border-radius: 12px;
  padding: 0.5rem 1rem;
  border: 1px solid rgba(88, 101, 242, 0.2);
}

.search-icon {
  color: #b0b3c1;
  margin-right: 0.5rem;
}

.search-form input {
  flex: 1 1;
  background: transparent;
  border: none;
  color: #ffffff;
  font-size: 1rem;
  outline: none;
}

.search-form button {
  background-color: #5865F2;
  color: #ffffff;
  border: none;
  padding: 0.5rem 1.5rem;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 600;
  transition: all 0.3s ease;
}

.search-form button:hover {
  background-color: #4752C4;
}

.category-filter {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: rgba(26, 26, 46, 0.6);
  border-radius: 12px;
  padding: 0.5rem 1rem;
  border: 1px solid rgba(88, 101, 242, 0.2);
}

.category-filter select {
  background: transparent;
  border: none;
  color: #ffffff;
  font-size: 1rem;
  outline: none;
  cursor: pointer;
}

.category-filter select option {
  background: #1a1a2e;
  color: #ffffff;
}

.links-table {
  background: rgba(26, 26, 46, 0.6);
  border-radius: 16px;
  overflow: hidden;
  border: 1px solid rgba(88, 101, 242, 0.2);
  margin-bottom: 2rem;
}

.links-table table {
  width: 100%;
  border-collapse: collapse;
}

.links-table thead {
  background: rgba(88, 101, 242, 0.1);
}

.links-table th,
.links-table td {
  padding: 1rem;
  text-align: left;
}

.links-table th {
  font-weight: 600;
  color: #b0b3c1;
}

.links-table tbody tr {
  border-top: 1px solid rgba(88, 101, 242, 0.1);
  transition: background-color 0.2s;
}

.links-table tbody tr:hover {
  background: rgba(88, 101, 242, 0.05);
}

.category-badge {
  padding: 0.25rem 0.75rem;
  border-radius: 20px;
  font-size: 0.85rem;
  font-weight: 600;
  display: inline-block;
}

.category-badge.nova {
  background: rgba(236, 72, 153, 0.2);
  color: #ec4899;
}

.category-badge.fayne {
  background: rgba(239, 68, 68, 0.2);
  color: #ef4444;
}

.url-cell a {
  color: #5865F2;
  text-decoration: none;
}

.url-cell a:hover {
  text-decoration: underline;
}

.actions-cell {
  display: flex;
  gap: 0.5rem;
}

.action-btn {
  background: transparent;
  border: none;
  color: #b0b3c1;
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 6px;
  transition: all 0.2s;
}

.action-btn:hover {
  background: rgba(88, 101, 242, 0.2);
  color: #5865F2;
}

.action-btn.delete:hover {
  background: rgba(239, 68, 68, 0.2);
  color: #ef4444;
}

.pagination {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  background: rgba(26, 26, 46, 0.6);
  border-radius: 12px;
  border: 1px solid rgba(88, 101, 242, 0.2);
}

.pagination button {
  background-color: #5865F2;
  color: #ffffff;
  border: none;
  padding: 0.5rem 1.5rem;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 600;
  transition: all 0.3s ease;
}

.pagination button:hover:not(:disabled) {
  background-color: #4752C4;
}

.pagination button:disabled {
  background-color: rgba(88, 101, 242, 0.3);
  cursor: not-allowed;
}

.no-data {
  text-align: center;
  color: #b0b3c1;
  padding: 3rem;
}

.download-status-btn {
  background: transparent;
  border: 2px solid;
  color: #b0b3c1;
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 6px;
  transition: all 0.2s;
  font-size: 1.1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 40px;
  height: 40px;
}

.download-status-btn.downloaded {
  border-color: #10b981;
  color: #10b981;
  background: rgba(16, 185, 129, 0.1);
}

.download-status-btn.downloaded:hover {
  background: rgba(16, 185, 129, 0.2);
  transform: scale(1.1);
}

.download-status-btn.not-downloaded {
  border-color: #6b7280;
  color: #6b7280;
}

.download-status-btn.not-downloaded:hover {
  background: rgba(107, 114, 128, 0.2);
  border-color: #5865F2;
  color: #5865F2;
  transform: scale(1.1);
}

.downloaded-row {
  background: rgba(16, 185, 129, 0.05);
}

.downloaded-row td {
  opacity: 0.8;
}
`, "",{"version":3,"sources":["webpack://./src/styles/Links.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,iCAAiC;EACjC,mBAAmB;EACnB,oBAAoB;EACpB,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,SAAO;EACP,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,iCAAiC;EACjC,mBAAmB;EACnB,oBAAoB;EACpB,yCAAyC;AAC3C;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;EACnB,gBAAgB;EAChB,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;AACrC;;AAEA;;EAEE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,6CAA6C;EAC7C,iCAAiC;AACnC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,iCAAiC;EACjC,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;EACnC,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;EACrB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,YAAY;AACd","sourcesContent":[".links-container {\n  padding: 2rem;\n  max-width: 1400px;\n  margin: 0 auto;\n}\n\n.links-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 2rem;\n}\n\n.links-header h1 {\n  font-size: 2.5rem;\n}\n\n.bulk-actions {\n  display: flex;\n  gap: 0.75rem;\n  flex-wrap: wrap;\n}\n\n.bulk-action-btn {\n  color: #ffffff;\n  border: none;\n  padding: 0.75rem 1.5rem;\n  border-radius: 8px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-weight: 600;\n  transition: all 0.3s ease;\n}\n\n.bulk-action-btn.downloaded {\n  background-color: #10b981;\n}\n\n.bulk-action-btn.downloaded:hover {\n  background-color: #059669;\n  transform: translateY(-2px);\n}\n\n.bulk-action-btn.not-downloaded {\n  background-color: #6b7280;\n}\n\n.bulk-action-btn.not-downloaded:hover {\n  background-color: #4b5563;\n  transform: translateY(-2px);\n}\n\n.bulk-action-btn.delete {\n  background-color: #ef4444;\n}\n\n.bulk-action-btn.delete:hover {\n  background-color: #dc2626;\n  transform: translateY(-2px);\n}\n\n.links-filters {\n  display: flex;\n  gap: 1rem;\n  margin-bottom: 2rem;\n  flex-wrap: wrap;\n}\n\n.search-form {\n  flex: 1;\n  min-width: 300px;\n  display: flex;\n  align-items: center;\n  background: rgba(26, 26, 46, 0.6);\n  border-radius: 12px;\n  padding: 0.5rem 1rem;\n  border: 1px solid rgba(88, 101, 242, 0.2);\n}\n\n.search-icon {\n  color: #b0b3c1;\n  margin-right: 0.5rem;\n}\n\n.search-form input {\n  flex: 1;\n  background: transparent;\n  border: none;\n  color: #ffffff;\n  font-size: 1rem;\n  outline: none;\n}\n\n.search-form button {\n  background-color: #5865F2;\n  color: #ffffff;\n  border: none;\n  padding: 0.5rem 1.5rem;\n  border-radius: 8px;\n  cursor: pointer;\n  font-weight: 600;\n  transition: all 0.3s ease;\n}\n\n.search-form button:hover {\n  background-color: #4752C4;\n}\n\n.category-filter {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  background: rgba(26, 26, 46, 0.6);\n  border-radius: 12px;\n  padding: 0.5rem 1rem;\n  border: 1px solid rgba(88, 101, 242, 0.2);\n}\n\n.category-filter select {\n  background: transparent;\n  border: none;\n  color: #ffffff;\n  font-size: 1rem;\n  outline: none;\n  cursor: pointer;\n}\n\n.category-filter select option {\n  background: #1a1a2e;\n  color: #ffffff;\n}\n\n.links-table {\n  background: rgba(26, 26, 46, 0.6);\n  border-radius: 16px;\n  overflow: hidden;\n  border: 1px solid rgba(88, 101, 242, 0.2);\n  margin-bottom: 2rem;\n}\n\n.links-table table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.links-table thead {\n  background: rgba(88, 101, 242, 0.1);\n}\n\n.links-table th,\n.links-table td {\n  padding: 1rem;\n  text-align: left;\n}\n\n.links-table th {\n  font-weight: 600;\n  color: #b0b3c1;\n}\n\n.links-table tbody tr {\n  border-top: 1px solid rgba(88, 101, 242, 0.1);\n  transition: background-color 0.2s;\n}\n\n.links-table tbody tr:hover {\n  background: rgba(88, 101, 242, 0.05);\n}\n\n.category-badge {\n  padding: 0.25rem 0.75rem;\n  border-radius: 20px;\n  font-size: 0.85rem;\n  font-weight: 600;\n  display: inline-block;\n}\n\n.category-badge.nova {\n  background: rgba(236, 72, 153, 0.2);\n  color: #ec4899;\n}\n\n.category-badge.fayne {\n  background: rgba(239, 68, 68, 0.2);\n  color: #ef4444;\n}\n\n.url-cell a {\n  color: #5865F2;\n  text-decoration: none;\n}\n\n.url-cell a:hover {\n  text-decoration: underline;\n}\n\n.actions-cell {\n  display: flex;\n  gap: 0.5rem;\n}\n\n.action-btn {\n  background: transparent;\n  border: none;\n  color: #b0b3c1;\n  cursor: pointer;\n  padding: 0.5rem;\n  border-radius: 6px;\n  transition: all 0.2s;\n}\n\n.action-btn:hover {\n  background: rgba(88, 101, 242, 0.2);\n  color: #5865F2;\n}\n\n.action-btn.delete:hover {\n  background: rgba(239, 68, 68, 0.2);\n  color: #ef4444;\n}\n\n.pagination {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1rem;\n  background: rgba(26, 26, 46, 0.6);\n  border-radius: 12px;\n  border: 1px solid rgba(88, 101, 242, 0.2);\n}\n\n.pagination button {\n  background-color: #5865F2;\n  color: #ffffff;\n  border: none;\n  padding: 0.5rem 1.5rem;\n  border-radius: 8px;\n  cursor: pointer;\n  font-weight: 600;\n  transition: all 0.3s ease;\n}\n\n.pagination button:hover:not(:disabled) {\n  background-color: #4752C4;\n}\n\n.pagination button:disabled {\n  background-color: rgba(88, 101, 242, 0.3);\n  cursor: not-allowed;\n}\n\n.no-data {\n  text-align: center;\n  color: #b0b3c1;\n  padding: 3rem;\n}\n\n.download-status-btn {\n  background: transparent;\n  border: 2px solid;\n  color: #b0b3c1;\n  cursor: pointer;\n  padding: 0.5rem;\n  border-radius: 6px;\n  transition: all 0.2s;\n  font-size: 1.1rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 40px;\n  height: 40px;\n}\n\n.download-status-btn.downloaded {\n  border-color: #10b981;\n  color: #10b981;\n  background: rgba(16, 185, 129, 0.1);\n}\n\n.download-status-btn.downloaded:hover {\n  background: rgba(16, 185, 129, 0.2);\n  transform: scale(1.1);\n}\n\n.download-status-btn.not-downloaded {\n  border-color: #6b7280;\n  color: #6b7280;\n}\n\n.download-status-btn.not-downloaded:hover {\n  background: rgba(107, 114, 128, 0.2);\n  border-color: #5865F2;\n  color: #5865F2;\n  transform: scale(1.1);\n}\n\n.downloaded-row {\n  background: rgba(16, 185, 129, 0.05);\n}\n\n.downloaded-row td {\n  opacity: 0.8;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
